// ヘッダーメニュー アクティブON・OFF
$('.header_list a').each(function (index, element) {
  if (element.href === window.location.href) {
    $(element).addClass('active')
  }
})
